<script>
    import { fade } from 'svelte/transition';
    // function that chooses from four random messages
    function randomMessage() {
      const messages = [
        "We don't want to disrupt the flow of the essay, so hold on to your thought until we finish this idea (which might be a paragraph or two). <i>-- 🤖 moderator</i>",
        "I see you! I'll get to you in a moment: I just want to make sure we finish this overall point. <i>-- 🤖 moderator</i>",
        "Hang tight: let's let this section finish, and then we'll get to your question. <i>-- 🤖 moderator</i>",
        "Almost done with this part! Then we'll take your question. <i>-- 🤖 moderator</i>"
      ];
      return messages[Math.floor(Math.random() * messages.length)];
    }
    let message = randomMessage();
  </script>
  
  <div 
    class="hand-container"
    transition:fade
  >
    <div class="gradient-circle">
      <span class="hand">👋</span>
    </div>
    <p class="status-text">
      <b>Hand raised!</b>
      <br />
      {@html message}
    </p>
  </div>
  
  <style>
    .hand-container {
      position: fixed;
      bottom: 5rem;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 1000;
    }
  
    .gradient-circle {
      width: 8rem;
      height: 8rem;
      background: radial-gradient(circle, white 60%, transparent 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
    }
  
    .hand {
      font-size: 4rem;
      animation: wave 1s infinite;
    }
  
    .status-text {
      margin-top: 0.5rem;
      font-size: 0.875rem;
      color: #4b5563;
      text-align: center;
    }
  
    @keyframes wave {
      0% { transform: rotate(0deg); }
      25% { transform: rotate(20deg); }
      50% { transform: rotate(0deg); }
      75% { transform: rotate(-20deg); }
      100% { transform: rotate(0deg); }
    }
    .status-text {
        margin-top: 0.5rem;
        font-size: 0.875rem;
        color: #4b5563;
        text-align: center;
        background: white;
        padding: 0.75rem 1.5rem;
        border-radius: 1rem;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
  </style>